/**
 * Created by toomasp on 05.07.2016.
 */
export class CasService {
    static $inject = ['config'];

    constructor(private cfg:Config) {
    }

    startLogin() {
        window.location.href = this.cfg.securityUrl
            + 'redirect?AUTH_TARGET='
            + encodeURIComponent(
                this.cfg.securityUrl
                + 'redirect?UI_PAGE='
                + encodeURIComponent(this.getThisPageUrl())
            );
    }

    private getThisPageUrl() {
        var url = window.location;
        if (!url.hash)
            return url.pathname;
        return url.pathname + url.hash;
    }
}


// WEBPACK FOOTER //
// ./src/main/ui/core/services/AuthenticationService.ts